<template>
  <section class="fine-prints">
    <span v-html="disclaimer" />
    <span v-if="secondaryDisclaimer" v-html="secondaryDisclaimer" />
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    disclaimer: String,
    secondaryDisclaimer: String
  }
};
</script>

<style>
</style>
